import './ErrorModal.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, DialogContainer } from 'react-md';
import { setErrorDialog } from '../../actions/errorDialog.action';

class ErrorModal extends Component {
  hide = () => {
    this.props.setErrorDialog({
      visible: false,
      error: null
    });
  }

  detailsList = (details) => {
    return details.map((detail, index) => {
      return <li key={index}>{detail.message}</li>;
    });
  }

  render() {
    const { error, visible } = this.props;
    const networkError = error && !error.response ? error.toString() : null;
    const errorData = error && error.response ? error.response.data : null;
    const errorResponse = errorData ? <p className="error-message">{errorData.message}</p> : null;
    const errorId = errorData ? <p className="error-id">Paste error {errorData.id} to #ops on slack.</p> : null;
    const errorStatus = errorData ? error.response.status : null;
    const title = errorStatus ? `Error: ${errorStatus}` : 'Error:';
    const errorDetails = errorData && errorData.details ? this.detailsList(errorData.details) : null;

    return (
      <div>
        <DialogContainer
          id='error-dialog'
          aria-labelledby='error-dialog'
          visible={visible}
          onHide={this.hide}
          modal
          title={networkError ? networkError : title}
        >
          <div className='dialog-container'>
            <div className='dialog-content'>
              {!networkError &&
                <div>
                  {errorResponse}
                  {errorDetails &&
                    <ul className='details-expansion'>
                      <h3>Details:</h3>
                      {errorDetails}
                    </ul>
                  }
                  {errorId}
                </div>
              }
            </div>
            <div className='dialog-footer'>
              <Button
                className='aknowledge-error'
                flat
                onClick={this.hide}
              >
                Dismiss
              </Button>
            </div>
          </div>
        </DialogContainer>
      </div>
    );
  }
}

const mapStateToProps = state => ({
});

export default connect(mapStateToProps, {
  setErrorDialog
})(ErrorModal);



// WEBPACK FOOTER //
// ./src/components/ErrorModal/ErrorModal.jsx